import React from 'react';
import {Button, Input} from "antd";

const TableInput = ({ defaultValue, completeHandler, disabled }) => {
  const [value, setValue] = React.useState(defaultValue);
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <Input value={value} onChange={(e) => setValue(e.target.value)} disabled={disabled} />
      <Button type="primary" onClick={() => completeHandler(value)} disabled={disabled}>Сохранить</Button>
    </div>
  );
};

export default TableInput;